import APIController from '../core-api-controller';

export const fetchCategoriesApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/categories${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const createCategoryApi = (data = {}) => {
  const path = `${APIController.endpointApi}/categories`;
  return APIController.postCallback(path, data);
};
